import { Component, OnInit, Input, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { ProductsService } from 'src/app/services/catalogs-services/products-services/products.service';
import { Subscription } from 'rxjs/internal/Subscription';
import { MatDialog } from '@angular/material';
import { ConfirmationDialogComponent } from '../../shared-components/confirmation-dialog/confirmation-dialog.component';
import { SnackBarService } from '../../shared-components/snack-bar/snack-bar.service';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-catalogs-products-list-card',
  templateUrl: './catalogs-products-list-card.component.html',
  styleUrls: ['./catalogs-products-list-card.component.scss']
})
export class CatalogsProductsListCardComponent implements OnInit, OnDestroy {

  @Input() products;
  filterOpts;
  filterKey;
  allSelected;
  searchProductsSubscription: Subscription;
  filterProductsSubscription: Subscription;
  deleteProductsSubscription: Subscription;

  constructor(private productsService: ProductsService,
              private dialog: MatDialog,
              private router: Router,
              private activatedRoute: ActivatedRoute,
              private snackbarService: SnackBarService,
              private cd: ChangeDetectorRef) {
                this.filterKey = '';
                this.allSelected = false;
              }

  ngOnInit() {
    this.filterProductsSubscription = this.productsService.filterProductsListen().subscribe(
      (res) => {
        this.filterOpts = res;
        this.cd.detectChanges();
      }
    );
    this.searchProductsSubscription = this.productsService.searchProductsListen().subscribe(
      (res) => {
        this.filterKey = res;
      }
    );
  }

  public gotoDetail(product) {
    this.router.navigate(['../product', product.InternalId], { relativeTo: this.activatedRoute.parent });
  }

  public deleteProducts() {
    const internalIds = this.products.filter(p => { if (p.selected) { return p; } }).map(p => p.InternalId);
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: {
        title: 'important',
        messages: ['catalogs-page.delete products', 'delete anyway']
      }
    });

    dialogRef.afterClosed().subscribe(action => {
      if (action) {
        this.deleteProductsSubscription = this.productsService.deleteProducts(internalIds).subscribe(
          (res) => {
            this.productsService.refreshProducts();
          },
          (error) => {
            this.snackbarService.open(error['error']['message'], 'error');
          }
        );
      }
    });
  }

  public select(item) {
    item.selected = !item.selected;
    this.allSelected = false;
    this.cd.detectChanges();
  }

  public selectAll() {
    this.allSelected = !this.allSelected;
    this.products.forEach(p => this.allSelected ? p.selected = true : p.selected = false);
    this.cd.detectChanges();
  }

  public search(event) {
    this.allSelected = false;
    this.products.forEach(p => p.selected = false);
    this.productsService.searchProducts(event.target.value);
    this.cd.detectChanges();
  }

  public getSelectedItems() {
    if (this.products && this.products.length > 0) {
      return this.products.filter(p => p.selected === true).length;
    }
  }

  ngOnDestroy() {
    if (this.searchProductsSubscription) { this.searchProductsSubscription.unsubscribe(); }
    if (this.filterProductsSubscription) { this.filterProductsSubscription.unsubscribe(); }
  }
}
